export default "__VITE_ASSET__8dJ_v5oG__"